import React from 'react'
import './root.css'
import 'vite/modulepreload-polyfill'
import { IContext, IOtherTarget } from './types'
import 'material-icons/iconfont/material-icons.css'
import renderComponent from './library/renderComponent'
import { createRoot } from "react-dom/client"
import ChatWrapper from './components/ChatPanel/ChatWrapper'
import { Listener } from './listener/listener'
import { setShareContent } from './atoms/shareContentAtom'

// addDOMPrototypes();
document.addEventListener("DOMContentLoaded", () => {
    // const chat: HTMLElement = document.querySelector('.chat') as HTMLElement
    // if (!chat) {
    //     return;
    // }
    // const { trigger, content, other } = chat.dataset
    // if (trigger == 'always') {
    //     chat.previousSiblingWithClass('overlay')?.classList.add('hidden')
    //     const root = createRoot(chat)
    //     root.render(
    //         <Chat context={content as IContext} other={null} container={null} element={null} />
    //     )
    // }

    renderComponent('socket-listener', () => <Listener />)

    renderComponent('chat', (dataset, container) => {
        const { context, other } = dataset
        if (!context) {
            return
        }
        let otherObject: IOtherTarget | null = null
        if (other) {
            otherObject = {
                user_id: other ? parseInt(other) : null,
            } as IOtherTarget
        }

        container.classList.add('chat-root')

        return <ChatWrapper context={context as IContext} other={otherObject} closePopup={null} helpMode={false} />
    })

    let popupRoot = null

    globalThis.DuscoShared.addEventBusListener('action-open-chat', ({ context, other, trigger, helpMode }) => {
        if (!context || !other) {
            return
        }

        const other_target = {
            user_id: other ? parseInt(other) : null,
        } as IOtherTarget


        const { renderWith, openPopup, closePopup } = globalThis.DuscoShared.createPopup({
            unmountOnClose: true,
            removeOnClose: true,
            wide: true,
            wider: true,
            showCloseOuter: true,
            noPadding: true,
        })

        openPopup()

        renderWith((content) => {
            popupRoot = createRoot(content)
            content.classList.add('chat-root')
            popupRoot.render(
                <ChatWrapper context={context as IContext} other={other_target} closePopup={closePopup} helpMode={helpMode === 'true' || helpMode === '1' || helpMode === true} />
            )
        })
    })

})


// @ts-ignore
if (globalThis.duscoSharedFile === undefined) {
    // @ts-ignore
    globalThis.duscoSharedFile = setShareContent
}


// Test only :
// setTimeout(() => {
//     // @ts-ignore
//     setShareContent({
//         name: 'test.txt',
//         mimeType: 'text/plain',
//         size: 100,
//         dataBase64: btoa('This is a test file content')
//     })
// }, 2000)


// export function create_chat_popup(origin: HTMLLabelElement) {
//     const { trigger, content, other } = origin.dataset
//     const id = generateUniqueId()
//     const chat_container = CreateDiv({ className: 'chat-popup-container' })
//     document.body.append(chat_container as Node)
//     origin.htmlFor = id

//     const chat_opened = CreateInput({ type: 'checkbox', parent: chat_container, style: { display: 'none' }, id })
//     const chat_overlay = CreateNode('label', { parent: chat_container, htmlFor: id })
//     const chat_window = CreateDiv({ parent: chat_container, className: 'chat-window' })

//     const root = createRoot(chat_window as Container)

//     setTimeout(() => panelShown = true, 1000)
//     root.render(
//         <Chat context={content as IContext} other={parseInt(other!)} container={chat_container} element={chat_window} />
//     )

// }

// @ts-ignore
// window.create_chat_popup = create_chat_popup
